import PropTypes from "prop-types";
import React from "react";

const SearchBox = ({
  value,
  placeholder,
  onChange,
  onReset,
  ...otherProps
}) => (
  <div className="p-search-box" {...otherProps}>
    <input
      type="search"
      className="p-search-box__input"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
    <button
      type="button"
      className={`p-search-box__reset u-no-margin--right ${
        value && onReset ? "" : "u-hide"
      }`}
      onClick={onReset}
    >
      <i className="p-icon--close" />
    </button>
    <button type="button" className="p-search-box__button">
      <i className="p-icon--search" />
    </button>
  </div>
);

SearchBox.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func
};

SearchBox.defaultProps = {
  value: "",
  placeholder: "",
  onReset: undefined
};

export default SearchBox;
